import LinkBase from '../LinkBase';
import styles from './link-sizable.module.less';

const LinkSizable = ({ className = '', ...restProps }) => {
    const classes = [styles.linkSizableDefault];

    return <LinkBase className={[...classes, className].join(' ')} {...restProps} />;
};

export default LinkSizable;
